module.exports = __webpack_public_path__ + "img/advantage5Green.d2766722.png";